/*eslint-disable eqeqeq*/
/**
 * Created by coolguy on 2017/8/13.
 */
import React from 'react';
import {Table, Button, Input} from 'antd';
import Add from './ProductListForAdd';
import {connect} from 'react-redux';
import {isWeb} from '../../util/index';
class ProductTable extends React.Component {
    constructor(props) {
        super();
        this.state = {
            visible: false,
            selectedList: props.selectedList || []
        }
    }

    getColumns = ()=>{
      return [/*{
          title: "产品ID",
          dataIndex: "id"
      }, */{
          title: "产品名称",
          dataIndex: "name"
      }, this.props.showPrice ? {
          title: "单价",
          dataIndex: "price",
          render: (price) => {
            // if(window.actionFor('order-info-cost', 'boolean')) {
            //     return '--.--';
            // }
            return ((price || 0) / 100).toFixed(2)
          }
      } : null, this.props.showPrice ? {
          title: "折扣",
          render: ({id,price}) => {
              let one = this.findOne(id);
              var result = (one.actualPrice ? (one.actualPrice * 100 /(one.number || 1) / price * 100).toFixed(0) : 100);
              if(isNaN(result) || !isFinite(result)) {
                  result = '100%';
              }else {
                  result += '%';
              }
              return result;
          }
      } : null, this.props.showPrice ? {
          title: "折后单价",
          render:({id, price})=>{
              let one = this.findOne(id);
              var result = (typeof one.actualPrice? (one.actualPrice * 100 /(one.number || 1) / price * 100) : 100);
              var value = "";
              if(isNaN(result) || !isFinite(result)) {
                  value = '0';
              }else {
                  value = (one.price * result / 10000).toFixed(0);
              }
              return <Input disabled={this.props.disabled} placeholder="不填写时默认数量为1来计算" value={typeof one.fatalPrice == 'undefined' ? value : one.fatalPrice} onChange={(e) => this.changeFatalPrice(id, e.target.value)}/>

          }
      } : null, {
          title: "数量",
          render: ({id}) => {
              return <Input disabled={this.props.disabled} placeholder="不填写时默认数量为1来计算" value={typeof this.findOne(id).number == 'undefined' ? 1 : this.findOne(id).number} onChange={(e) => this.changeNumber(id, e.target.value)}/>
          }
      }, this.props.showPrice ? {
          title: "小计",
          render: ({id, price,number}) => {
              return <Input disabled={this.props.disabled} placeholder="默认为单价*数量" value={typeof this.findOne(id).actualPrice != 'undefined' ? this.findOne(id).actualPrice : (number || 1)* (price / 100).toFixed(2)}
                            onChange={(e) => this.changePrice(id, e.target.value)}/>
          }
      } : null];
    }

    findOne = (id) => {
        return this.state.selectedList.find((one) => {
            return one.id == id;
        })
    }
    changeFatalPrice = (id, value) =>{
        let one = this.findOne(id);
        one.actualPrice = (value || 0) * one.number;
        one.fatalPrice = value;
        this.setState({},()=>{
            this.props.onChange && this.props.onChange(this.state.selectedList);
        });
    }
    changeNumber = (id, value) => {
        let one = this.findOne(id);
        one.number = value;
        one.actualPrice = (one.fatalPrice * 1) * (one.number || 1);
        this.setState({},()=>{
            this.props.onChange && this.props.onChange(this.state.selectedList);
        });
    }
    changePrice = (id, value) => {
        if(!value) {
            value = 0;
        }
        value = Number(value * 100) / 100;
        var one = this.findOne(id);
        one.actualPrice = value;
        one.fatalPrice = (value / one.number).toFixed(2);
        this.setState({},()=>{
            this.props.onChange && this.props.onChange(this.state.selectedList);
        });
    }
    showAddProduct = () => {
        this.setState({
            visible: true,
        })
    }
    hideAddProduct = () => {
        this.setState({
            visible: false
        })
    }
    getSelected = (selectedIds) => {
        let selectedList = this.props.productList.filter((one) => {
            return ~selectedIds.findIndex((id) => {
                return id == one.id
            })
        });
        selectedList = selectedList.map(item=>{
          // 如果在原始产品里能找到，则使用之前的数据，不要给重置了
          let prod = this.state.selectedList.find(it=>it.id == item.id);
          if(prod) {
            return prod;
          }else {
            item.number = 1;
            item.actualPrice = (item.price * 1 / 100).toFixed(2);
            item.fatalPrice = (item.price * 1 / 100).toFixed(2);
            return item;
          }
        });
        this.setState({
            selectedList
        },()=>{
            this.props.onChange && this.props.onChange(this.state.selectedList);
        })

        this.hideAddProduct();
    }
    // getTotal = ()=>{
    //     return this.state.selectedList.reduce((sum,current)=>{
    //         let currentPrice = current.actualPrice !== undefined ? current.actualPrice : current.price/100;
    //         return sum  + (currentPrice-0)
    //     },0).toFixed(2)
    // }
    getList = ()=>{
        return this.state.selectedList;
    }

    render() {
        let list = this.state.selectedList;
        let {productList, selectedList, disabled} = this.props;

        let selectedIds = (selectedList || []).map(it=>it.id);

        if(!(list instanceof Array)){
            list = []
        }
        if(productList) {
            list = list.map((prod)=>{
                if(typeof prod.price == 'undefined') {
                    var exist = productList.find(p=>p.id==prod.id);
                    if(exist) {
                        prod.price = exist.price;
                    }else {
                        prod.price = ((prod.actualPrice * 100) / (prod.number * 1)).toFixed(2);
                    }
                }

                return prod;
            });
        }

        var realcol = this.getColumns().filter(it=>!!it);
        let tableProps = {
          columns:realcol,
          dataSource:list,
          pagination:false,
          rowKey:'id',
          tableLayout:'fixed',
          size:'small'
        };

        if(!isWeb()) {
          tableProps.scroll = {x:'calc(100vw - 48px)'};
        }
        return (
            <div className="product-table">
                <Table {...tableProps}/>
                {disabled ? null : <div><Button {...window.actionFor('order-edit')} type={"primary"} style={{marginTop:10}} onClick={this.showAddProduct}>添加产品</Button></div>}
                <Add onChange={this.getSelected} visible={this.state.visible} data={selectedIds}
                     hide={this.hideAddProduct}/>
            </div>
        )
    }
}

export default connect((state) => ({
    productList: state.productList
}))(ProductTable)



// WEBPACK FOOTER //
// ./src/components/Select/ProductTable.js